export const Platform = {
  OS: "web" as const,
  select: <T>(obj: { web?: T; default?: T }): T | undefined => obj.web ?? obj.default,
};

export const Linking = {
  openURL: (url: string) => window.open(url, "_blank"),
  getInitialURL: async () => window.location.href,
  addEventListener: () => ({ remove: () => {} }),
  removeEventListener: () => {},
};

export const NativeModules = {};

export class AnimatedValue {
  _value: number;
  constructor(val: number) {
    this._value = val;
  }
  setValue = (val: number) => {
    this._value = val;
  };
  interpolate = () => ({});
}

export const Animated = {
  Value: AnimatedValue,
  timing: () => ({ start: (cb: () => void) => cb?.(), stop: () => {} }),
  loop: (anim: { start: (cb: () => void) => void }) => anim,
  sequence: (anim: { start: (cb: () => void) => void }[]) => anim[0],
  View: "div" as unknown as React.ComponentType,
};

export const RefreshControl = "div" as unknown as React.ComponentType;
export const SectionList = "div" as unknown as React.ComponentType;
export const Switch = "input" as unknown as React.ComponentType;
export const Modal = "div" as unknown as React.ComponentType;
export const ActivityIndicator = "div" as unknown as React.ComponentType;
export const TouchableOpacity = "button" as unknown as React.ComponentType;
export const FlatList = "div" as unknown as React.ComponentType;
export const SafeAreaView = "div" as unknown as React.ComponentType;
export const AppState = {
  addEventListener: () => ({ remove: () => {} }),
};

export const StyleSheet = {
  create: <T>(styles: T) => styles,
};

export const Alert = {
  alert: () => {},
};

export const Pressable = "button" as unknown as React.ComponentType;
export const Text = "span" as unknown as React.ComponentType;
export const TextInput = "input" as unknown as React.ComponentType;
export const View = "div" as unknown as React.ComponentType;
export const ScrollView = "div" as unknown as React.ComponentType;
export const Image = "img" as unknown as React.ComponentType;
export const KeyboardAvoidingView = "div" as unknown as React.ComponentType;

export class NativeEventEmitter {
  private listeners: Map<string, Set<(...args: unknown[]) => void>> = new Map();

  addListener(eventType: string, listener: (...args: unknown[]) => void) {
    if (!this.listeners.has(eventType)) {
      this.listeners.set(eventType, new Set());
    }
    this.listeners.get(eventType)?.add(listener);
    return { remove: () => this.removeAllListeners(eventType) };
  }

  removeAllListeners(eventType: string) {
    this.listeners.get(eventType)?.clear();
  }

  emit(eventType: string, ...args: unknown[]) {
    this.listeners.get(eventType)?.forEach((listener) => {
      listener(...args);
    });
  }

  removeSubscription() {}

  getListenersOfType(eventType: string) {
    return Array.from(this.listeners.get(eventType) ?? []);
  }
}

export const TurboModuleRegistry = {
  getEnforcing: <T>(_name: string): T => {
    return {} as T;
  },
  get: <T>(_name: string): T | null => {
    return null;
  },
};

export const Dimensions = {
  get: () => ({ width: 1024, height: 768 }),
};

export const useWindowDimensions = () => ({ width: 1024, height: 768 });
